import React from 'react';
import styled from 'styled-components';

interface ShimmerTextProps {
  text: string;
  isDarkMode?: boolean;
  className?: string;
}

const ShimmerContainer = styled.div<{ $isDark: boolean }>`
  .shimmer-text {
    font-family: 'Lato', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
    font-weight: 600;
    font-size: inherit;
    letter-spacing: 0.2px;
    text-align: inherit;
    display: inline-block;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    color: ${({ $isDark }) => ($isDark ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.8)')};
    background: linear-gradient(
      90deg,
      ${({ $isDark }) => ($isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)')} 0%,
      ${({ $isDark }) => ($isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)')} 35%,
      ${({ $isDark }) => ($isDark ? 'rgba(255,255,255,1)' : 'rgba(0,0,0,1)')} 50%,
      ${({ $isDark }) => ($isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)')} 65%,
      ${({ $isDark }) => ($isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)')} 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 180px 100%;
    animation: shimmer var(--shimmer-duration, 1.6s) linear infinite;
  }

  @keyframes shimmer {
    0% {
      background-position: 0% 0;
    }
    100% {
      background-position: 180px 0;
    }
  }
`;

export const ShimmerText: React.FC<ShimmerTextProps> = ({ text, isDarkMode = true, className }) => {
  return (
    <ShimmerContainer $isDark={isDarkMode}>
      <span className={`shimmer-text ${className || ''}`}>{text}</span>
    </ShimmerContainer>
  );
};

export default ShimmerText;



